import Link from 'next/link'

import classNames from 'classnames'

import type { PortableTextComponentProps } from '~/components/atoms/BlockContent/BlockContent'
import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import Container from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import Image from '~/components/atoms/Image/Image'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import type { ComponentTheme } from '~/components/themes'

import styles from './CategoryHero.module.css'

export interface CategoryHeroProps {
  name: string
  summary?: PortableTextComponentProps['blocks'] | string
  testID?: string
  theme?: ComponentTheme
  podcastInfo?: {
    listenOnTitle: string
    listenOn: {
      link: string
      logo: any
    }[]
  }
}

export default function CategoryHero({
  name,
  summary,
  podcastInfo,
  theme,
  testID,
}: CategoryHeroProps) {
  return (
    <div className={styles.base} data-testid={testID}>
      <Fixture verticalPadding theme={theme}>
        <Container>
          <Text
            size={TextSizes.magPrimaryTitleXLrg}
            Tag="h1"
            className={classNames(styles.title, summary && styles.marginBottom)}
            uppercase
          >
            {name}
          </Text>
          {summary && (
            <div className={styles.mw}>
              {summary &&
                (typeof summary === 'string' ? (
                  <Text size={TextSizes.bodyLrg} Tag="p">
                    {summary}
                  </Text>
                ) : (
                  <BlockContent
                    value={summary}
                    size={TextSizes.bodyLrg}
                  ></BlockContent>
                ))}
            </div>
          )}
          {podcastInfo?.listenOn && (
            <div className={styles.categoryInfoLinkContainer}>
              <Text
                size={TextSizes.bodyLrg}
                Tag="h2"
                className={styles.listenOnTitle}
              >
                {podcastInfo.listenOnTitle || 'Listen on:'}
              </Text>
              <div className={styles.categoryLinks}>
                {podcastInfo.listenOn.map((link, index) => (
                  <Link
                    key={index}
                    href={link.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.categoryLink}
                  >
                    <Image asset={link.logo.asset} alt={link.link} />
                  </Link>
                ))}
              </div>
            </div>
          )}
        </Container>
      </Fixture>
    </div>
  )
}
